import React from 'react';
import { ProjectsList } from '../components/ProjectComponents';
import ProjectDetail from './ProjectDetail';
import { Layout } from '../Layout';

const Projects: React.FC = () => {
    const maybeSlug = window.location.pathname.split('/projects/')[1];
    const isDetail  = Boolean(maybeSlug);

    return (
        <Layout>
            {isDetail ? <ProjectDetail /> : <ProjectsList />}
        </Layout>
    );
};

export default Projects;
